import { PricingTypeDisplay } from '~/constants';
import { Project } from '~/types/project';

export default function headerText(project: Project, projectState: any) {
  const pricingTypeDisplay = projectState?.isEpcOperating ? 'Project acquisition' : PricingTypeDisplay[project?.pricingType];
  return `Bidding ${pricingTypeDisplay ? ` on ${pricingTypeDisplay}` : ''}`;
}